(function () {
    'use strict';
    angular
        .module('app.performanceInteractionReport')
        .controller('performanceInteractionReportCtrl', ['$scope', '$rootScope', '$http', '$state', '$location', 'adminService', 'performanceInteractionReportService',
            function ($scope, $rootScope, $http, $state, $location, adminService, performanceInteractionReportService) {
                $scope.currentUser = $rootScope.currentUser;
                $scope.currentPage = 1;
                $scope.pageSize = 10;
                $scope.isEnable = false;

                $scope.getInteractionReport = function(params) {
                    var result = null;
                    params.page_no = $scope.currentPage;

                    performanceInteractionReportService.getInteractionReportData(params)
                        .then(function(response){
                            var result = response.data;
                            angular.forEach(response.data.posts, function(item) {
                                item.title  = item.title.replace(/\uFFFD/g, '');
                            });
                            $scope.totalRow = result.totalRows;
                            $scope.interactionData = result;
                            $scope.interactionData.kpi.audience = roundKPINumber($scope.interactionData.kpi.audience);
                            $scope.interactionData.kpi.interaction = roundKPINumber($scope.interactionData.kpi.interaction);
                            $scope.pagination();
                        })
                        .catch(function(message){
                        })
                        .finally(function(){
                            $rootScope.$broadcast('sectionLoaded');
                        });
                };

                function getInteractionReportData() {
                    var params = $rootScope.saveParams;
                    if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0 && params._workaround_group_id == 0))
                    {
                        $scope.isEnable = false;
                        return;
                    }
                    $scope.isEnable = true;
                    params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

                    $scope.getInteractionReport(params);
                };

                $scope.pagination = function() {
                    $scope.pages = adminService.pagination($scope.totalRow, $scope.pageSize);
                };

                $scope.updatePage = function(val) {
                    $scope.currentPage = val;
                    getInteractionReportData();
                };

                $scope.getPlatformIcon = function (id) {
                    return adminService.getPlatformIcon(id);
                };

                $scope.roundNumber = function (numb) {
                    return Math.round(numb*10)/10;
                };

                $scope.postOverviewPage = function(post) {
                    $rootScope.previousPagePost = $location.absUrl();
                    if (post.platform === 1) {
                        $state.transitionTo('home.blogPostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (post.platform === 2) {
                        $state.transitionTo('home.instagramPostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (post.platform === 6) {
                        $state.transitionTo('home.youtubePostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (post.platform === 7) {
                        $state.transitionTo('home.facebookPostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    }
                };

                /* truncate decimal number
                * num: number
                * decPos: position of decimal
                */
                function truncateToDecimals(num, decPos) {
                    var calcDec = Math.pow(10, decPos);
                    return Math.trunc(num * calcDec) / calcDec;
                }

                function roundKPINumber(nummber) {
                    var result;
                    result = (nummber / 1000000) >= 1 ? truncateToDecimals(nummber / 1000000, 1) + 'M' : (nummber / 1000) > 1 ? Math.round((nummber / 1000)*10)/10 + 'K' : Math.round(nummber);
                    return result;
                };

                // first initiating
                getInteractionReportData();

                //Watch on change keyword / blog / project change
                $scope.$on('refreshDashboard', function(event, args) {
                    getInteractionReportData();
                });
            }
        ]);
})();